import io from "socket.io-client";

const baseUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";
let socket = null;

export default () => {
	if (!socket) {
		socket = io(baseUrl, {
			path: '/socket.io'
		});
	}

	return socket;
}
